/*This component will render a card using props passed by the "GameCardsWrapper"*/
const GameCard = ({ item, id, handleClick }) => {
  // Declaring a variable to add classes to the "item.stat".
  const itemClass = item.stat ? " active " + item.stat : "";
  return (
    // Here the "itemClass" created above is added to the "item.stat" property that we get by its "id" onClick.
    <div className={"game-card" + itemClass} onClick={() => handleClick(id)}>
      <img src={item.img} alt={item.id} />
    </div>
  );
};

export default GameCard;
